export const GPH_LANDING_URL =
  process.env.REACT_APP_GPH_LANDING_URL || 'https://gameprohub.com.br';

const TECHNICAL_FIELD_PATTERN =
  /\b(primary_symptoms|secondary_symptoms|diagnosticPayload|rawResult|payload|free_text|severity|stack trace|traceback|conversationId|uid|analysis_jobs)\b/i;

const SAFE_TEXT_KEYS = new Set([
  'title',
  'heading',
  'label',
  'text',
  'content',
  'body',
  'summary',
  'description',
  'message',
  'caption',
  'subtitle',
  'value',
  'name'
]);

const SAFE_COLLECTION_KEYS = new Set([
  'items',
  'lines',
  'bullets',
  'rows',
  'cells',
  'columns',
  'sections',
  'steps'
]);

export const sanitizeMessagePlainText = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value)
    .replace(/\r/g, '')
    .replace(/\[object Object\]/g, '')
    .split('\n')
    .map((line) => line.trimEnd())
    .filter((line) => !TECHNICAL_FIELD_PATTERN.test(line))
    .join('\n')
    .replace(/[{}[\]"]/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  if (TECHNICAL_FIELD_PATTERN.test(text)) return '';
  return text;
};

const collectSafeText = (value, output, depth = 0) => {
  if (depth > 4 || value === null || value === undefined) return;

  if (typeof value === 'string' || typeof value === 'number') {
    const clean = sanitizeMessagePlainText(value);
    if (clean) output.push(clean);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectSafeText(item, output, depth + 1));
    return;
  }

  if (typeof value !== 'object') return;

  Object.entries(value).forEach(([key, nestedValue]) => {
    if (TECHNICAL_FIELD_PATTERN.test(key)) return;
    if (SAFE_TEXT_KEYS.has(key) || SAFE_COLLECTION_KEYS.has(key)) {
      collectSafeText(nestedValue, output, depth + 1);
    }
  });
};

export const getMessagePlainText = (message = {}) => {
  const output = [];

  if (message.text) collectSafeText(message.text, output);
  if (message.content) collectSafeText(message.content, output);
  if (message.displayBlocks) collectSafeText(message.displayBlocks, output);

  if (message.context) {
    collectSafeText(
      {
        title: message.context.title,
        subtitle: message.context.subtitle,
        summary: message.context.summary,
        message: message.context.message,
        description: message.context.description,
        body: message.context.body,
        text: message.context.text,
        resultText: message.context.resultText,
        blockedReason: message.context.blockedReason
      },
      output
    );
  }

  return Array.from(new Set(output))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export const buildMiShareText = (message, landingUrl = GPH_LANDING_URL) => {
  const text = getMessagePlainText(message);
  const url = sanitizeMessagePlainText(landingUrl);
  if (!text) return url;

  return `${text}\n\nCriado com a Mi, coach virtual de FPS Mobile do Game Pro Hub:\n${url}`.trim();
};
